import { combineReducers } from 'redux';
import { createBaseAsyncReducer } from '../redux-util/async-helpers';
import * as cfg from './watson-config-action';
import { createSimpleKeyValueReducer } from '../redux-util/general-helpers';

const standardAsync = [cfg.LOCALE_KEY, cfg.BRAND_KEY, cfg.THEME_KEY];

function getReducers(keys, fn) {
  return keys.map(k => ({ [k]: fn(k) })).reduce((acc, cv) => {
    return Object.assign(acc, cv);
  }, {});
}

export default combineReducers({
  ...getReducers(standardAsync, createBaseAsyncReducer),
  [cfg.UIBASE_KEY]: createSimpleKeyValueReducer(cfg.UIBASE_KEY, ''),
});



// WEBPACK FOOTER //
// ./src/app/api/redux-watson/watson-reducer.js